import { useCallback } from 'react';
import { useTheme } from '@mui/material';
import { Capacitor } from '@capacitor/core';

/**
 * iOS only: an invisible fixed bar across the bottom safe-area that absorbs
 * touch/drag events, so an upward swipe from the bottom edge reaches the iOS
 * system gesture (app switcher / Home) instead of being read by the WKWebView
 * as a scroll that drags bottom-sheet drawers. Pass to a bottom sheet's
 * `sibling` prop. Renders nothing on non-iOS platforms.
 */
export const IosAppSwitcherHandler = (): JSX.Element | null => {
  const theme = useTheme();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const swallowEvent = useCallback((e: any) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  if (Capacitor.getPlatform() !== 'ios') {
    return null;
  }

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: 'calc(env(safe-area-inset-bottom) / 2)',
        pointerEvents: 'auto',
        touchAction: 'none',
        zIndex: theme.zIndex.drawer + 2,
      }}
      onDragStart={swallowEvent}
      onDrag={swallowEvent}
      onDragEnd={swallowEvent}
      onTouchStart={swallowEvent}
      onTouchMove={swallowEvent}
      onTouchEnd={swallowEvent}
    />
  );
};
